module.exports = __webpack_public_path__ + "img/16d004-24.6c071253.jpg";